import React, { useState, useEffect, useRef } from 'react';
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import { setVendorName } from '../../redux/actions/vendorAction';
import HttpService from '../../services/httpService';
import { connect } from 'react-redux';
import { useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import TableHead from '@material-ui/core/TableHead';
import { Button, CircularProgress, Grid, FormControl, InputLabel, Select, MenuItem, Box, Typography } from '@material-ui/core';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';
import ClearIcon from '@material-ui/icons/Clear';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import { RiFileExcel2Fill } from "react-icons/ri";
import { CSVLink } from "react-csv";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
    marginBottom: '20px',
  },
  title: {
    fontWeight: 700,
    color: '#1e293b',
    marginBottom: '32px',
    textAlign: 'center',
  },
  headerCell: {
    backgroundColor: '#1C375D',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '18px',
    padding: '20px',
    borderRight: '1px solid rgba(255,255,255,0.2)',
    position: 'sticky',
    top: 0,
    textAlign: 'center',
    zIndex: 1,
  },
  tableheaderCell: {
    backgroundColor: '#1C375D',
    color: 'white',
    padding: '20px',
    borderRight: '1px solid rgba(255,255,255,0.2)',
    position: 'sticky',
    top: 0,
    textAlign: 'center',
    zIndex: 2,
  },
  tableRowEven: {
    backgroundColor: '#ffffff',
  },
  tableRowOdd: {
    backgroundColor: '#f0f4f8',
  },
  cell: {
    fontSize: '16px',
    fontWeight: 'bold',
    padding: '20px',
    borderRight: '1px solid #e0e0e0',
    color: '#263238',
    textAlign: 'center',
  },
  tablecell: {
    padding: '20px',
    borderRight: '1px solid #e0e0e0',
    color: '#263238',
    textAlign: 'center',
  },
  valueCell: {
    fontSize: '18px',
    fontWeight: 'bold',
    padding: '20px',
    color: '#0d47a1',
    borderRight: '1px solid #e0e0e0',
    textAlign: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e3f2fd',
    },
  },
  paper: {
    textAlign: 'center',
  },
  detailsTableContainer: {
    marginTop: '20px',
    animation: 'fadeIn 0.5s ease-in-out',
  },
  '@keyframes fadeIn': {
    from: {
      opacity: 0,
      transform: 'translateY(-20px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  dialogPaper: {
    minWidth: '80%',
    maxWidth: '90%',
    height: '80vh',
    margin: '20px',
  },
  dialogTitle: {
    backgroundColor: '#1C375D',
    color: 'white',
    '& .MuiTypography-root': {
      fontWeight: 'bold',
    },
  },
  closeButton: {
    position: 'absolute',
    right: '10px',
    top: '10px',
    color: 'white',
  },
  dialogContent: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - 40px)',
  },
  tableWrapper: {
    flex: 1,
    overflow: 'auto',
    marginBottom: '16px',
  },
  paginationWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 0',
    marginTop: 'auto',
  },
  downloadButton: {
    backgroundColor: "#355025",
    color: "#FFF2EB",
    '&:hover': {
      backgroundColor: "#2a401e",
    },
    '&.Mui-disabled': {
      backgroundColor: "#ccc",
      color: "#666",
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px',
  },
  sectionTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1C375D',
    marginTop: '30px',
    marginBottom: '15px',
    padding: '10px',
    backgroundColor: '#f5f5f5',
    borderRadius: '8px',
  },
  subNote: {
    fontSize: '12px',
    color: 'white',
    fontStyle: 'bold',
    marginBottom: '12px',
    padding: '6px 10px',
    backgroundColor: '#1C375D',
    borderLeft: '3px solid #ff9800',
    borderRadius: '4px',
    fontWeight: 700,
  },
  tableContainer: {
    marginTop: '20px',
    marginBottom: '30px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  filterContainer: {
    padding: '16px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    marginBottom: '16px',
  },
  editableDateContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    flexWrap: 'wrap',
  },
  dateInput: {
    padding: '6px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '12px',
    width: '130px',
  },
  selectInput: {
    padding: '6px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '12px',
    width: '100px',
  },
  textInput: {
    padding: '6px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '12px',
    width: '150px',
  },
  editButton: {
    padding: '2px',
  },
  filterButton: {
    marginBottom: '10px',
    marginRight: '10px',
  },
  projectLink: {
    color: '#0d47a1',
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: '#1565c0',
    },
  },
}));

const RfdExecutiveDashboarad = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector(state => state.user);
  const { setLoading, setSnackInfo } = props;
  
  // State declarations
  const [csvData, setCsvData] = useState([]);
  const [showDetailsDialog, setShowDetailsDialog] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState(null);
  const [selectedMetricData, setSelectedMetricData] = useState([]);
  const [page, setPage] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  // Filter states for Yes DSO table
  const [yesDsoFilters, setYesDsoFilters] = useState({
    projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: ''
  });
  const [filteredYesDsoData, setFilteredYesDsoData] = useState([]);
  const [showYesDsoFilters, setShowYesDsoFilters] = useState(false);

  // Filter states for Second DSO table
  const [secondDsoFilters, setSecondDsoFilters] = useState({
    projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: '', startDate: '', endDate: ''
  });
  const [filteredSecondDsoData, setFilteredSecondDsoData] = useState([]);
  const [showSecondDsoFilters, setShowSecondDsoFilters] = useState(false);

  // Filter states for Third DSO table
  const [thirdDsoFilters, setThirdDsoFilters] = useState({
    projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: ''
  });
  const [filteredThirdDsoData, setFilteredThirdDsoData] = useState([]);
  const [showThirdDsoFilters, setShowThirdDsoFilters] = useState(false);

  // Filter states for Other DSO table (NEW)
  const [otherDsoFilters, setOtherDsoFilters] = useState({
    projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: ''
  });
  const [filteredOtherDsoData, setFilteredOtherDsoData] = useState([]);
  const [showOtherDsoFilters, setShowOtherDsoFilters] = useState(false);

  // Filter states for Payment table
  const [paymentFilters, setPaymentFilters] = useState({
    projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: ''
  });
  const [filteredPaymentData, setFilteredPaymentData] = useState([]);
  const [showPaymentFilters, setShowPaymentFilters] = useState(false);

  // Filter states for Updated Payment Date table
  const [updatedPaymentFilters, setUpdatedPaymentFilters] = useState({
    projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: '', startDate: '', endDate: ''
  });
  const [filteredUpdatedPaymentData, setFilteredUpdatedPaymentData] = useState([]);
  const [showUpdatedPaymentFilters, setShowUpdatedPaymentFilters] = useState(false);


  const [tableTotalCounts, setTableTotalCounts] = useState({
    yesDso: 0, secondDso: 0, thirdDso: 0, otherDso: 0, payment: 0, updatedPayment: 0
  });

  
  const [yesDsoDebouncedFilters, setYesDsoDebouncedFilters] = useState(yesDsoFilters);
  const [secondDsoDebouncedFilters, setSecondDsoDebouncedFilters] = useState(secondDsoFilters);
  const [thirdDsoDebouncedFilters, setThirdDsoDebouncedFilters] = useState(thirdDsoFilters);
  const [otherDsoDebouncedFilters, setOtherDsoDebouncedFilters] = useState(otherDsoFilters);
  const [paymentDebouncedFilters, setPaymentDebouncedFilters] = useState(paymentFilters);
  const [updatedPaymentDebouncedFilters, setUpdatedPaymentDebouncedFilters] = useState(updatedPaymentFilters);

 
  const [filterOptions, setFilterOptions] = useState({
    yesDso: { locations: [], stages: [] },
    secondDso: { locations: [], stages: [] },
    thirdDso: { locations: [], stages: [] },
    otherDso: { locations: [], stages: [] },
    payment: { locations: [], stages: [] },
    updatedPayment: { locations: [], stages: [] }
  });
  const mergeFilterOptions = (tableKey, rows) => {
    setFilterOptions(prev => {
      const locations = new Set(prev[tableKey].locations);
      const stages = new Set(prev[tableKey].stages);
      rows.forEach(row => {
        const loc = row?.cityName || row?.location;
        if (loc && loc !== 'NA') locations.add(loc);
        if (row?.currentStage && row.currentStage !== 'NA') stages.add(row.currentStage);
      });
      return { ...prev, [tableKey]: { locations: [...locations], stages: [...stages] } };
    });
  };
  
  const [loadingState, setLoadingState] = useState({
    idso: false,
    dso: false,
    paymentPopup: false, // the "Payment" metric-card popup's own fetch
    payment: false, // the persistent, server-paginated "Payment Collected" table's fetch
    yesDso: false,
    secondDso: false,
    thirdDso: false,
    otherDso: false // NEW
  });
  
  // Data states
  const [idsoCount, setIdsoCount] = useState(0);
  const [idsoCountData, setIdsoCountData] = useState([]);
  const [dsoCount, setDsoCount] = useState(0);
  const [dsoCountData, setDsoCountData] = useState([]);
  const [paymentCount, setPaymentCount] = useState(0);
  const [paymentCountData, setPaymentCountData] = useState([]); // feeds the "Payment" metric-card popup only
  const [paymentTableData, setPaymentTableData] = useState([]); // feeds the persistent, server-paginated "Payment Collected" table
  const [yesDsoData, setYesDsoData] = useState([]);
  const [secondDsoData, setSecondDsoData] = useState([]);
  const [thirdDsoData, setThirdDsoData] = useState([]);
  const [otherDsoData, setOtherDsoData] = useState([]); // NEW
  const [updatedPaymentDateData, setUpdatedPaymentDateData] = useState([]);
  const [updatedPaymentDateLoading, setUpdatedPaymentDateLoading] = useState(false);
  const [updatedPaymentDatePage, setUpdatedPaymentDatePage] = useState(0);
  const [updatedPaymentDateRowsPerPage, setUpdatedPaymentDateRowsPerPage] = useState(10);
  
  // Pagination states
  const [yesDsoPage, setYesDsoPage] = useState(0);
  const [yesDsoRowsPerPage, setYesDsoRowsPerPage] = useState(10);
  const [secondDsoPage, setSecondDsoPage] = useState(0);
  const [secondDsoRowsPerPage, setSecondDsoRowsPerPage] = useState(10);
  const [thirdDsoPage, setThirdDsoPage] = useState(0);
  const [thirdDsoRowsPerPage, setThirdDsoRowsPerPage] = useState(10);
  const [otherDsoPage, setOtherDsoPage] = useState(0); // NEW
  const [otherDsoRowsPerPage, setOtherDsoRowsPerPage] = useState(10); // NEW
  const [paymentTablePage, setPaymentTablePage] = useState(0);
  const [paymentTableRowsPerPage, setPaymentTableRowsPerPage] = useState(10);
  
  // Editable states for different fields
  const [editingCell, setEditingCell] = useState({ projectId: null, field: null });
  const [editValue, setEditValue] = useState('');
  const [isUpdating, setIsUpdating] = useState(false);
  
  const csvRef = useRef();

  // Helper function to open project link in new tab
  const handleProjectClick = (projectId) => {
    window.open(`/project-logs/${projectId}`, '_blank');
  };

  // Patches one row's field, in place, across every table already loaded on screen — the edit is
  // reflected instantly without waiting on any network round trip, since we already know the new
  // value (we just set it).
  const patchRowLocally = (projectId, fieldName, value) => {
    const patch = (setter) => setter(prev => prev.map(row => (row._id === projectId ? { ...row, [fieldName]: value } : row)));
    patch(setYesDsoData);
    patch(setSecondDsoData);
    patch(setThirdDsoData);
    patch(setOtherDsoData);
    patch(setPaymentTableData);
    patch(setUpdatedPaymentDateData);
  };

  // Generic function to handle all updates
  const handleFieldUpdate = async (projectId, fieldName, value, tableKey) => {
    if (!value && value !== '') {
      props.setSnackInfo?.("Please enter a value", "warning");
      return;
    }

    setIsUpdating(true);
    try {
      const response = await HttpService.updatePaymentDate({
        leadId: projectId,
        fieldName: fieldName,
        value: value
      });

      if (response.success === true || response.status === 200) {
        // Reflect the new value immediately in every table that already holds this row.
        patchRowLocally(projectId, fieldName, value);
        props.setSnackInfo?.(`${fieldName} updated successfully`, "success");
        setEditingCell({ projectId: null, field: null });
        setEditValue('');

        // Refetch only the ONE table this edit was made in — not every table a bucket-defining
        // field (propertyPossession/hasKeys/materialDeliveryWilling) could theoretically move a
        // lead into, and not "Updated Payment Date" just because expectedPaymentDate changed.
        // If a lead does move DSO buckets as a result of this edit, the *other* bucket won't show
        // it until that table is itself next refreshed — a deliberate trade-off so committing an
        // edit only ever costs one table's fetch, not several.
        const tableFetchers = {
          yesDso: DsoPaymentNotCollectedYesCondition,
          secondDso: DsoPaymentNotCollectedSecondCondition,
          thirdDso: DsoPaymentNotCollectedThirdCondition,
          otherDso: DsoPaymentNotCollectedOtherCondition,
          payment: fetchPaymentTableData,
          updatedPayment: fetchUpdatedPaymentDateData
        };
        tableFetchers[tableKey]?.().catch(err => console.error(`Background ${tableKey} refresh failed:`, err));
      } else {
        props.setSnackInfo?.("Failed to update", "error");
      }
    } catch (error) {
      console.error('Error:', error);
      props.setSnackInfo?.("Error updating field", "error");
    } finally {
      setIsUpdating(false);
    }
  };

  // Editable Date Cell Component
  const EditableDateCell = ({ date, projectId, fieldName, label, tableKey }) => {
    const isEditing = editingCell.projectId === projectId && editingCell.field === fieldName;
    
    return (
      <div className={classes.editableDateContainer}>
        {isEditing ? (
          <>
            <input 
              type="date" 
              value={editValue} 
              onChange={(e) => setEditValue(e.target.value)} 
              disabled={isUpdating} 
              className={classes.dateInput} 
              autoFocus 
            />
            <IconButton size="small" onClick={() => handleFieldUpdate(projectId, fieldName, editValue, tableKey)} disabled={isUpdating}>
              <CheckIcon style={{ fontSize: '14px', color: '#4caf50' }} />
            </IconButton>
            <IconButton size="small" onClick={() => { setEditingCell({ projectId: null, field: null }); setEditValue(''); }} disabled={isUpdating}>
              <CloseIcon style={{ fontSize: '14px', color: '#f44336' }} />
            </IconButton>
          </>
        ) : (
          <>
            <span>{date ? moment(date).format('DD-MM-YYYY') : 'Not Set'}</span>
            <IconButton 
              size="small" 
              onClick={() => { 
                setEditingCell({ projectId: projectId, field: fieldName }); 
                setEditValue(date ? moment(date).format('YYYY-MM-DD') : ''); 
              }}
            >
              <EditIcon style={{ fontSize: '14px', color: '#1C375D' }} />
            </IconButton>
          </>
        )}
      </div>
    );
  };

  // Editable Select Cell Component (for Possession Status & Key Status)
  const EditableSelectCell = ({ value, options, projectId, fieldName, label, tableKey }) => {
    const isEditing = editingCell.projectId === projectId && editingCell.field === fieldName;
    
    return (
      <div className={classes.editableDateContainer}>
        {isEditing ? (
          <>
            <select 
              value={editValue} 
              onChange={(e) => setEditValue(e.target.value)} 
              disabled={isUpdating}
              className={classes.selectInput}
            >
              <option value="">Select</option>
              {options.map(opt => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
            <IconButton size="small" onClick={() => handleFieldUpdate(projectId, fieldName, editValue, tableKey)} disabled={isUpdating}>
              <CheckIcon style={{ fontSize: '14px', color: '#4caf50' }} />
            </IconButton>
            <IconButton size="small" onClick={() => { setEditingCell({ projectId: null, field: null }); setEditValue(''); }} disabled={isUpdating}>
              <CloseIcon style={{ fontSize: '14px', color: '#f44336' }} />
            </IconButton>
          </>
        ) : (
          <>
            <span>{value || 'Not Set'}</span>
            <IconButton 
              size="small" 
              onClick={() => { 
                setEditingCell({ projectId: projectId, field: fieldName }); 
                setEditValue(value || ''); 
              }}
            >
              <EditIcon style={{ fontSize: '14px', color: '#1C375D' }} />
            </IconButton>
          </>
        )}
      </div>
    );
  };

  // Editable Text Cell Component (for Remark)
  const EditableTextCell = ({ value, projectId, fieldName, label, tableKey }) => {
    const isEditing = editingCell.projectId === projectId && editingCell.field === fieldName;
    
    return (
      <div className={classes.editableDateContainer}>
        {isEditing ? (
          <>
            <input 
              type="text" 
              value={editValue} 
              onChange={(e) => setEditValue(e.target.value)} 
              disabled={isUpdating}
              className={classes.textInput}
              autoFocus
            />
            <IconButton size="small" onClick={() => handleFieldUpdate(projectId, fieldName, editValue, tableKey)} disabled={isUpdating}>
              <CheckIcon style={{ fontSize: '14px', color: '#4caf50' }} />
            </IconButton>
            <IconButton size="small" onClick={() => { setEditingCell({ projectId: null, field: null }); setEditValue(''); }} disabled={isUpdating}>
              <CloseIcon style={{ fontSize: '14px', color: '#f44336' }} />
            </IconButton>
          </>
        ) : (
          <>
            <span style={{ maxWidth: '150px', display: 'inline-block', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {value || 'Click to add remark'}
            </span>
            <IconButton 
              size="small" 
              onClick={() => { 
                setEditingCell({ projectId: projectId, field: fieldName }); 
                setEditValue(value || ''); 
              }}
            >
              <EditIcon style={{ fontSize: '14px', color: '#1C375D' }} />
            </IconButton>
          </>
        )}
      </div>
    );
  };

 
  useEffect(() => {
    const t = setTimeout(() => { setYesDsoDebouncedFilters(yesDsoFilters); setYesDsoPage(0); }, 400);
    return () => clearTimeout(t);
  }, [yesDsoFilters]);

  useEffect(() => {
    const t = setTimeout(() => { setSecondDsoDebouncedFilters(secondDsoFilters); setSecondDsoPage(0); }, 400);
    return () => clearTimeout(t);
  }, [secondDsoFilters]);

  useEffect(() => {
    const t = setTimeout(() => { setThirdDsoDebouncedFilters(thirdDsoFilters); setThirdDsoPage(0); }, 400);
    return () => clearTimeout(t);
  }, [thirdDsoFilters]);

  useEffect(() => {
    const t = setTimeout(() => { setOtherDsoDebouncedFilters(otherDsoFilters); setOtherDsoPage(0); }, 400);
    return () => clearTimeout(t);
  }, [otherDsoFilters]);

  useEffect(() => {
    const t = setTimeout(() => { setPaymentDebouncedFilters(paymentFilters); setPaymentTablePage(0); }, 400);
    return () => clearTimeout(t);
  }, [paymentFilters]);

  useEffect(() => {
    const t = setTimeout(() => { setUpdatedPaymentDebouncedFilters(updatedPaymentFilters); setUpdatedPaymentDatePage(0); }, 400);
    return () => clearTimeout(t);
  }, [updatedPaymentFilters]);

  // CSV Headers
  const idsoCsvHeaders = [
    { label: "S. No", key: "serialNo" },
    { label: "Project No", key: "projectCode" },
    { label: "Lead No.", key: "leadNo" },
    { label: "Client Name", key: "clientName" },
    { label: "Contact No.", key: "contactNo" },
    { label: "Location", key: "location" },
    { label: "Current Stage", key: "currentStage" },
  ];

  const dsoCsvHeaders = [
    { label: "S. No", key: "serialNo" },
    { label: "Project No", key: "projectCode" },
    { label: "Lead No.", key: "leadNo" },
    { label: "Client Name", key: "clientName" },
    { label: "Contact No.", key: "contactNo" },
    { label: "Experience Center", key: "experienceCenter" },
    { label: "Location", key: "location" },
    { label: "Current Stage", key: "currentStage" },
    { label: "Design Sign Off Date", key: "designSignOffDate" },
  ];

  const paymentCsvHeaders = [
    { label: "S. No", key: "serialNo" },
    { label: "Project No", key: "projectCode" },
    { label: "Lead No.", key: "leadNo" },
    { label: "Client Name", key: "clientName" },
    { label: "Contact No.", key: "contactNo" },
    { label: "Experience Center", key: "experienceCenter" },
    { label: "Location", key: "location" },
    { label: "Current Stage", key: "currentStage" },
    { label: "Design Sign Off Date", key: "designSignOffDate" },
  ];

  const yesDsoCsvHeaders = [
    { label: "S. No", key: "serialNo" },
    { label: "Project No", key: "projectCode" },
    { label: "Client Name", key: "clientName" },
    { label: "Contact", key: "contact" },
    { label: "Location", key: "location" },
    { label: "Current Stage", key: "currentStage" },
    { label: "Design SignOff Date", key: "designSignOffDate" },
    { label: "Due Amount", key: "dueAmount" },
    { label: "Expected Payment Date", key: "expectedPaymentDate" },
  ];

  const secondDsoCsvHeaders = [
    { label: "S. No", key: "serialNo" },
    { label: "Project No", key: "projectCode" },
    { label: "Client Name", key: "clientName" },
    { label: "Contact", key: "contact" },
    { label: "Location", key: "location" },
    { label: "Current Stage", key: "currentStage" },
    { label: "Design SignOff Date", key: "designSignOffDate" },
    { label: "Due Amount", key: "dueAmount" },
    { label: "Possession Status", key: "possessionStatus" },
    { label: "Possession Date", key: "possessionDate" },
    { label: "Key Status", key: "keyStatus" },
    { label: "Expected Payment Date", key: "expectedPaymentDate" },
  ];

  const thirdDsoCsvHeaders = [
    { label: "S. No", key: "serialNo" },
    { label: "Project No", key: "projectCode" },
    { label: "Client Name", key: "clientName" },
    { label: "Contact", key: "contact" },
    { label: "Location", key: "location" },
    { label: "Current Stage", key: "currentStage" },
    { label: "Design SignOff Date", key: "designSignOffDate" },
    { label: "Due Amount", key: "dueAmount" },
    { label: "Key Status", key: "keyStatus" },
    { label: "Payment Date", key: "paymentDate" },
    { label: "Expected Payment Date", key: "expectedPaymentDate" },
  ];

  // NEW: Other DSO CSV Headers
  const otherDsoCsvHeaders = [
    { label: "S. No", key: "serialNo" },
    { label: "Project No", key: "projectCode" },
    { label: "Client Name", key: "clientName" },
    { label: "Contact", key: "contact" },
    { label: "Location", key: "location" },
    { label: "Current Stage", key: "currentStage" },
    { label: "Design SignOff Date", key: "designSignOffDate" },
    { label: "Due Amount", key: "dueAmount" },
    { label: "Possession Status", key: "possessionStatus" },
    { label: "Possession Date", key: "possessionDate" },
    { label: "Key Status", key: "keyStatus" },
    { label: "Material Delivery Willing", key: "materialDeliveryWilling" },
    { label: "Expected Payment Date", key: "expectedPaymentDate" },
  ];

  const paymentTableCsvHeaders = [
    { label: "S. No", key: "serialNo" },
    { label: "Project No", key: "projectCode" },
    { label: "Lead No.", key: "leadNo" },
    { label: "Client Name", key: "clientName" },
    { label: "Contact", key: "contact" },
    { label: "Location", key: "location" },
    { label: "Current Stage", key: "currentStage" },
    { label: "Collected Amount", key: "collectedAmount" },
    { label: "Payment Collection Date", key: "paymentCollectionDate" },
    { label: "Pending Days", key: "pendingDays" },
    { label: "Expected Material Date", key: "expectedMaterialDate" },
    { label: "Remark", key: "remark" },
  ];

  const updatedPaymentDateCsvHeaders = [
    { label: "S. No", key: "serialNo" },
    { label: "Project No", key: "erpProjectNo" },
    { label: "Lead No.", key: "leadNo" },
    { label: "Client Name", key: "clientName" },
    { label: "Contact", key: "contact" },
    { label: "Location", key: "location" },
    { label: "Current Stage", key: "currentStage" },
    { label: "Expected Payment Date", key: "expectedPaymentDate" },
    { label: "Due Amount", key: "dueAmount" },
    { label: "Last Communication", key: "lastCommunication" },
  ];

  const tableData = [
    { metric: "IDSO", value: idsoCount || 0, type: "idso" },
    { metric: "DSO Payment Not Collected", value: dsoCount || 0, type: "dso" },
    { metric: "Payment Collected Not in Under Execution", value: paymentCount || 0, type: "payment" }
  ];

  // Download handlers for dialog
  const handleDialogDownload = () => {
    let csvFormattedData = [];
    let headers = [];
    let filename = "";

    if (selectedMetric === "IDSO") {
      headers = idsoCsvHeaders;
      filename = "idso-drawings-data.csv";
      csvFormattedData = selectedMetricData.map((item, index) => ({
        serialNo: index + 1,
        projectCode: item.erpProjectNo || "NA",
        leadNo: item.lead_no || "NA",
        clientName: item?.customerId?.name || "NA",
        // contactNo: item?.customerId?.contact_no || "NA",
        location: item?.cityName || "NA",
        currentStage: item?.currentStage || "NA",
      }));
    } else if (selectedMetric === "DSO Payment Not Collected") {
      headers = dsoCsvHeaders;
      filename = "dso-payment-not-collected-data.csv";
      csvFormattedData = selectedMetricData.map((item, index) => ({
        serialNo: index + 1,
        projectCode: item.erpProjectNo || "NA",
        leadNo: item.lead_no || "NA",
        clientName: item?.customer?.name || item?.customerId?.name || "NA",
        // contactNo: item?.customer?.contact_no || item?.customerId?.contact_no || "NA",
        experienceCenter: item?.experienceCenterName || "NA",
        location: item?.cityName || "NA",
        currentStage: item?.currentStage || "NA",
        designSignOffDate: item?.customerDesignSignOffDate ? moment(item.customerDesignSignOffDate).format('DD-MM-YYYY') : "NA",
      }));
    } else if (selectedMetric === "Payment Collected Not in Under Execution") {
      headers = paymentCsvHeaders;
      filename = "payment-collected-data.csv";
      csvFormattedData = selectedMetricData.map((item, index) => ({
        serialNo: index + 1,
        projectCode: item.erpProjectNo || "NA",
        leadNo: item.lead_no || "NA",
        clientName: item?.customer?.name || item?.customerId?.name || "NA",
        // contactNo: item?.customer?.contact_no || item?.customerId?.contact_no || "NA",
        experienceCenter: item?.experienceCenterName || "NA",
        location: item?.cityName || "NA",
        currentStage: item?.currentStage || "NA",
        designSignOffDate: item?.customerDesignSignOffDate ? moment(item.customerDesignSignOffDate).format('DD-MM-YYYY') : "NA",
      }));
    }

    setCsvData(csvFormattedData);
    setTimeout(() => {
      if (csvRef.current) {
        csvRef.current.link.click();
      }
    }, 100);
  };


  const buildServerFilterParams = (filters) => ({
    projectNo: filters.projectNo,
    location: filters.location,
    currentStage: filters.currentStage,
    minDueAmount: filters.minDueAmount,
    maxDueAmount: filters.maxDueAmount,
    startDate: filters.startDate,
    endDate: filters.endDate
  });


  const downloadCsv = (rows, headers, filename) => {
    const csvData = [headers.map(h => h.label), ...rows.map(item => headers.map(h => item[h.key]))];
    const csvContent = csvData.map(row => row.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
  };

  const handleYesDsoDownload = async () => {
    setLoading(true);
    try {
      const response = await HttpService.DsoPaymentNotCollectedYesCondition({ limit: -1, ...buildServerFilterParams(yesDsoDebouncedFilters) });
      const csvFormattedData = (response?.data?.data || []).map((item, index) => ({
        serialNo: index + 1,
        projectCode: item.erpProjectNo || "NA",
        clientName: item?.customer?.name || item?.customerId?.name || "NA",
        location: item?.cityName || "NA",
        currentStage: item?.currentStage || "NA",
        designSignOffDate: item?.customerDesignSignOffDate ? moment(item.customerDesignSignOffDate).format('DD-MM-YYYY') : "NA",
        dueAmount: item?.dueAmount || "NA",
        expectedPaymentDate: item?.expectedPaymentDate ? moment(item.expectedPaymentDate).format('DD-MM-YYYY') : "NA",
      }));
      downloadCsv(csvFormattedData, yesDsoCsvHeaders, "dso-yes-condition-data.csv");
    } catch (error) {
      console.error("Error downloading Yes DSO CSV:", error);
      setSnackInfo?.("Couldn't prepare CSV export", "error");
    }
    setLoading(false);
  };

  const handleSecondDsoDownload = async () => {
    setLoading(true);
    try {
      const response = await HttpService.DsoPaymentNotCollectedSecondCondition({ limit: -1, ...buildServerFilterParams(secondDsoDebouncedFilters) });
      const csvFormattedData = (response?.data?.data || []).map((item, index) => ({
        serialNo: index + 1,
        projectCode: item.erpProjectNo || "NA",
        clientName: item?.customer?.name || item?.customerId?.name || "NA",
        location: item?.cityName || "NA",
        currentStage: item?.currentStage || "NA",
        designSignOffDate: item?.customerDesignSignOffDate ? moment(item.customerDesignSignOffDate).format('DD-MM-YYYY') : "NA",
        dueAmount: item?.dueAmount || "NA",
        possessionStatus: item?.propertyPossession || "NA",
        possessionDate: item?.propertyPossessionDate ? moment(item.propertyPossessionDate).format('DD-MM-YYYY') : "NA",
        keyStatus: item?.hasKeys || "NA",
        expectedPaymentDate: item?.expectedPaymentDate ? moment(item.expectedPaymentDate).format('DD-MM-YYYY') : "NA",
      }));
      downloadCsv(csvFormattedData, secondDsoCsvHeaders, "dso-second-condition-data.csv");
    } catch (error) {
      console.error("Error downloading Second DSO CSV:", error);
      setSnackInfo?.("Couldn't prepare CSV export", "error");
    }
    setLoading(false);
  };

  const handleThirdDsoDownload = async () => {
    setLoading(true);
    try {
      const response = await HttpService.DsoPaymentNotCollectedThirdCondition({ limit: -1, ...buildServerFilterParams(thirdDsoDebouncedFilters) });
      const csvFormattedData = (response?.data?.data || []).map((item, index) => ({
        serialNo: index + 1,
        projectCode: item.erpProjectNo || "NA",
        clientName: item?.customer?.name || item?.customerId?.name || "NA",
        location: item?.cityName || "NA",
        currentStage: item?.currentStage || "NA",
        designSignOffDate: item?.customerDesignSignOffDate ? moment(item.customerDesignSignOffDate).format('DD-MM-YYYY') : "NA",
        dueAmount: item?.dueAmount || "NA",
        keyStatus: item?.hasKeys || "NA",
        paymentDate: item?.materialDeliveryDate || "NA",
        expectedPaymentDate: item?.expectedPaymentDate ? moment(item.expectedPaymentDate).format('DD-MM-YYYY') : "NA",
      }));
      downloadCsv(csvFormattedData, thirdDsoCsvHeaders, "dso-third-condition-data.csv");
    } catch (error) {
      console.error("Error downloading Third DSO CSV:", error);
      setSnackInfo?.("Couldn't prepare CSV export", "error");
    }
    setLoading(false);
  };

  // NEW: Other DSO Download handler
  const handleOtherDsoDownload = async () => {
    setLoading(true);
    try {
      const response = await HttpService.DsoPaymentNotCollectedOtherCondition({ limit: -1, ...buildServerFilterParams(otherDsoDebouncedFilters) });
      const csvFormattedData = (response?.data?.data || []).map((item, index) => ({
        serialNo: index + 1,
        projectCode: item.erpProjectNo || "NA",
        clientName: item?.customer?.name || item?.customerId?.name || "NA",
        location: item?.cityName || "NA",
        currentStage: item?.currentStage || "NA",
        designSignOffDate: item?.customerDesignSignOffDate ? moment(item.customerDesignSignOffDate).format('DD-MM-YYYY') : "NA",
        dueAmount: item?.dueAmount || "NA",
        possessionStatus: item?.propertyPossession || "NA",
        possessionDate: item?.propertyPossessionDate ? moment(item.propertyPossessionDate).format('DD-MM-YYYY') : "NA",
        keyStatus: item?.hasKeys || "NA",
        materialDeliveryWilling: item?.materialDeliveryWilling || "NA",
        expectedPaymentDate: item?.expectedPaymentDate ? moment(item.expectedPaymentDate).format('DD-MM-YYYY') : "NA",
      }));
      downloadCsv(csvFormattedData, otherDsoCsvHeaders, "dso-other-conditions-data.csv");
    } catch (error) {
      console.error("Error downloading Other DSO CSV:", error);
      setSnackInfo?.("Couldn't prepare CSV export", "error");
    }
    setLoading(false);
  };

  const handlePaymentTableDownload = async () => {
    setLoading(true);
    try {
      const response = await HttpService.PaymentCollectedNotinUnderExecution({ limit: -1, ...buildServerFilterParams(paymentDebouncedFilters) });
      const csvFormattedData = (response?.data?.data || []).map((item, index) => ({
        serialNo: index + 1,
        projectCode: item.erpProjectNo || "NA",
        leadNo: item.lead_no || item.uniqueLeadNumber || "NA",
        clientName: item?.customer?.name || "NA",
        location: item?.cityName || "NA",
        currentStage: item?.currentStage || "NA",
        collectedAmount: item?.totalPaid || 0,
        paymentCollectionDate: item?.lastPaymentDate ? moment(item.lastPaymentDate).format('DD-MM-YYYY') : "NA",
        pendingDays: item?.pendingDays || "NA",
        expectedMaterialDate: item?.expectedmaterialDeliveryDate ? moment(item.expectedmaterialDeliveryDate).format('DD-MM-YYYY') : "NA",
        remark: item?.remark || "NA",
      }));
      downloadCsv(csvFormattedData, paymentTableCsvHeaders, "payment-collected-not-in-under-execution.csv");
    } catch (error) {
      console.error("Error downloading Payment CSV:", error);
      setSnackInfo?.("Couldn't prepare CSV export", "error");
    }
    setLoading(false);
  };

  const handleUpdatedPaymentDateDownload = () => {
    setLoading(true);
    HttpService.getUpdatePaymentDate({ limit: -1, ...buildServerFilterParams(updatedPaymentDebouncedFilters) })
      .then(response => {
        const csvFormattedData = (response?.data?.data || []).map((item, index) => ({
          serialNo: index + 1,
          erpProjectNo: item.erpProjectNo || "NA",
          leadNo: item.lead_no || "NA",
          clientName: item?.customer?.name || "NA",
          location: item?.cityName || "NA",
          currentStage: item?.currentStage || "NA",
          expectedPaymentDate: item?.expectedPaymentDate ? moment(item.expectedPaymentDate).format('DD-MM-YYYY') : "NA",
          dueAmount: item?.dueAmount || "NA",
          lastCommunication: item?.lastCommunicationDate ? moment(item.lastCommunicationDate).format('DD-MM-YYYY') : "NA",
        }));
        downloadCsv(csvFormattedData, updatedPaymentDateCsvHeaders, "updated-expected-payment-date.csv");
      })
      .catch(error => {
        console.error("Error downloading Updated Payment Date CSV:", error);
        setSnackInfo?.("Couldn't prepare CSV export", "error");
      })
      .finally(() => setLoading(false));
  };

  // Pagination handlers
  const handleChangeRowPerPage = (event) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  const handleYesDsoPageChange = (event, newPage) => {
    setYesDsoPage(newPage);
  };

  const handleYesDsoRowsPerPageChange = (event) => {
    setYesDsoRowsPerPage(Number(event.target.value));
    setYesDsoPage(0);
  };

  const handleSecondDsoPageChange = (event, newPage) => {
    setSecondDsoPage(newPage);
  };

  const handleSecondDsoRowsPerPageChange = (event) => {
    setSecondDsoRowsPerPage(Number(event.target.value));
    setSecondDsoPage(0);
  };

  const handleThirdDsoPageChange = (event, newPage) => {
    setThirdDsoPage(newPage);
  };

  const handleThirdDsoRowsPerPageChange = (event) => {
    setThirdDsoRowsPerPage(Number(event.target.value));
    setThirdDsoPage(0);
  };

  // NEW: Other DSO pagination handlers
  const handleOtherDsoPageChange = (event, newPage) => {
    setOtherDsoPage(newPage);
  };

  const handleOtherDsoRowsPerPageChange = (event) => {
    setOtherDsoRowsPerPage(Number(event.target.value));
    setOtherDsoPage(0);
  };

  const handlePaymentTablePageChange = (event, newPage) => {
    setPaymentTablePage(newPage);
  };

  const handlePaymentTableRowsPerPageChange = (event) => {
    setPaymentTableRowsPerPage(Number(event.target.value));
    setPaymentTablePage(0);
  };

  const handleUpdatedPaymentDatePageChange = (event, newPage) => {
    setUpdatedPaymentDatePage(newPage);
  };

  const handleUpdatedPaymentDateRowsPerPageChange = (event) => {
    setUpdatedPaymentDateRowsPerPage(Number(event.target.value));
    setUpdatedPaymentDatePage(0);
  };

  // Clear filters for tables
  const clearYesDsoFilters = () => {
    setYesDsoFilters({
      projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: ''
    });
  };

  const clearSecondDsoFilters = () => {
    setSecondDsoFilters({
      projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: '', startDate: '', endDate: ''
    });
  };

  const clearThirdDsoFilters = () => {
    setThirdDsoFilters({
      projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: ''
    });
  };

  // NEW: Clear Other DSO filters
  const clearOtherDsoFilters = () => {
    setOtherDsoFilters({
      projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: ''
    });
  };

  const clearPaymentFilters = () => {
    setPaymentFilters({
      projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: ''
    });
  };

  const clearUpdatedPaymentFilters = () => {
    setUpdatedPaymentFilters({
      projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: '', startDate: '', endDate: ''
    });
  };

  // Render filter sections
  const renderYesDsoFilterSection = () => {
    const locations = filterOptions.yesDso.locations;
    const stages = filterOptions.yesDso.stages;
    
    return (
      <div className={classes.filterContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Project No"
              variant="outlined"
              value={yesDsoFilters.projectNo}
              onChange={(e) => setYesDsoFilters({ ...yesDsoFilters, projectNo: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Location</InputLabel>
              <Select
                value={yesDsoFilters.location}
                onChange={(e) => setYesDsoFilters({ ...yesDsoFilters, location: e.target.value })}
                label="Location"
              >
                <MenuItem value="">All</MenuItem>
                {locations.map(loc => (
                  <MenuItem key={loc} value={loc}>{loc}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Current Stage</InputLabel>
              <Select
                value={yesDsoFilters.currentStage}
                onChange={(e) => setYesDsoFilters({ ...yesDsoFilters, currentStage: e.target.value })}
                label="Current Stage"
              >
                <MenuItem value="">All</MenuItem>
                {stages.map(stage => (
                  <MenuItem key={stage} value={stage}>{stage}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Min Due Amount"
              type="number"
              variant="outlined"
              value={yesDsoFilters.minDueAmount}
              onChange={(e) => setYesDsoFilters({ ...yesDsoFilters, minDueAmount: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Max Due Amount"
              type="number"
              variant="outlined"
              value={yesDsoFilters.maxDueAmount}
              onChange={(e) => setYesDsoFilters({ ...yesDsoFilters, maxDueAmount: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end">
              <Button
                size="small"
                variant="contained"
                color="secondary"
                startIcon={<ClearIcon />}
                onClick={clearYesDsoFilters}
              >
                Clear All Filters
              </Button>
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  };

  const renderSecondDsoFilterSection = () => {
    const locations = filterOptions.secondDso.locations;
    const stages = filterOptions.secondDso.stages;
    
    return (
      <div className={classes.filterContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Project No"
              variant="outlined"
              value={secondDsoFilters.projectNo}
              onChange={(e) => setSecondDsoFilters({ ...secondDsoFilters, projectNo: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Location</InputLabel>
              <Select
                value={secondDsoFilters.location}
                onChange={(e) => setSecondDsoFilters({ ...secondDsoFilters, location: e.target.value })}
                label="Location"
              >
                <MenuItem value="">All</MenuItem>
                {locations.map(loc => (
                  <MenuItem key={loc} value={loc}>{loc}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Current Stage</InputLabel>
              <Select
                value={secondDsoFilters.currentStage}
                onChange={(e) => setSecondDsoFilters({ ...secondDsoFilters, currentStage: e.target.value })}
                label="Current Stage"
              >
                <MenuItem value="">All</MenuItem>
                {stages.map(stage => (
                  <MenuItem key={stage} value={stage}>{stage}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Min Due Amount"
              type="number"
              variant="outlined"
              value={secondDsoFilters.minDueAmount}
              onChange={(e) => setSecondDsoFilters({ ...secondDsoFilters, minDueAmount: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Max Due Amount"
              type="number"
              variant="outlined"
              value={secondDsoFilters.maxDueAmount}
              onChange={(e) => setSecondDsoFilters({ ...secondDsoFilters, maxDueAmount: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Start Possession Date"
              type="date"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              value={secondDsoFilters.startDate}
              onChange={(e) => setSecondDsoFilters({ ...secondDsoFilters, startDate: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="End Possession Date"
              type="date"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              value={secondDsoFilters.endDate}
              onChange={(e) => setSecondDsoFilters({ ...secondDsoFilters, endDate: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end">
              <Button
                size="small"
                variant="contained"
                color="secondary"
                startIcon={<ClearIcon />}
                onClick={clearSecondDsoFilters}
              >
                Clear All Filters
              </Button>
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  };

  const renderThirdDsoFilterSection = () => {
    const locations = filterOptions.thirdDso.locations;
    const stages = filterOptions.thirdDso.stages;
    
    return (
      <div className={classes.filterContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Project No"
              variant="outlined"
              value={thirdDsoFilters.projectNo}
              onChange={(e) => setThirdDsoFilters({ ...thirdDsoFilters, projectNo: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Location</InputLabel>
              <Select
                value={thirdDsoFilters.location}
                onChange={(e) => setThirdDsoFilters({ ...thirdDsoFilters, location: e.target.value })}
                label="Location"
              >
                <MenuItem value="">All</MenuItem>
                {locations.map(loc => (
                  <MenuItem key={loc} value={loc}>{loc}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Current Stage</InputLabel>
              <Select
                value={thirdDsoFilters.currentStage}
                onChange={(e) => setThirdDsoFilters({ ...thirdDsoFilters, currentStage: e.target.value })}
                label="Current Stage"
              >
                <MenuItem value="">All</MenuItem>
                {stages.map(stage => (
                  <MenuItem key={stage} value={stage}>{stage}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Min Due Amount"
              type="number"
              variant="outlined"
              value={thirdDsoFilters.minDueAmount}
              onChange={(e) => setThirdDsoFilters({ ...thirdDsoFilters, minDueAmount: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Max Due Amount"
              type="number"
              variant="outlined"
              value={thirdDsoFilters.maxDueAmount}
              onChange={(e) => setThirdDsoFilters({ ...thirdDsoFilters, maxDueAmount: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end">
              <Button
                size="small"
                variant="contained"
                color="secondary"
                startIcon={<ClearIcon />}
                onClick={clearThirdDsoFilters}
              >
                Clear All Filters
              </Button>
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  };

  // NEW: Other DSO Filter Section
  const renderOtherDsoFilterSection = () => {
    const locations = filterOptions.otherDso.locations;
    const stages = filterOptions.otherDso.stages;
    
    return (
      <div className={classes.filterContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Project No"
              variant="outlined"
              value={otherDsoFilters.projectNo}
              onChange={(e) => setOtherDsoFilters({ ...otherDsoFilters, projectNo: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Location</InputLabel>
              <Select
                value={otherDsoFilters.location}
                onChange={(e) => setOtherDsoFilters({ ...otherDsoFilters, location: e.target.value })}
                label="Location"
              >
                <MenuItem value="">All</MenuItem>
                {locations.map(loc => (
                  <MenuItem key={loc} value={loc}>{loc}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Current Stage</InputLabel>
              <Select
                value={otherDsoFilters.currentStage}
                onChange={(e) => setOtherDsoFilters({ ...otherDsoFilters, currentStage: e.target.value })}
                label="Current Stage"
              >
                <MenuItem value="">All</MenuItem>
                {stages.map(stage => (
                  <MenuItem key={stage} value={stage}>{stage}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Min Due Amount"
              type="number"
              variant="outlined"
              value={otherDsoFilters.minDueAmount}
              onChange={(e) => setOtherDsoFilters({ ...otherDsoFilters, minDueAmount: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Max Due Amount"
              type="number"
              variant="outlined"
              value={otherDsoFilters.maxDueAmount}
              onChange={(e) => setOtherDsoFilters({ ...otherDsoFilters, maxDueAmount: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end">
              <Button
                size="small"
                variant="contained"
                color="secondary"
                startIcon={<ClearIcon />}
                onClick={clearOtherDsoFilters}
              >
                Clear All Filters
              </Button>
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  };

  const renderPaymentFilterSection = () => {
    const locations = filterOptions.payment.locations;
    const stages = filterOptions.payment.stages;
    
    return (
      <div className={classes.filterContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Project No"
              variant="outlined"
              value={paymentFilters.projectNo}
              onChange={(e) => setPaymentFilters({ ...paymentFilters, projectNo: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Location</InputLabel>
              <Select
                value={paymentFilters.location}
                onChange={(e) => setPaymentFilters({ ...paymentFilters, location: e.target.value })}
                label="Location"
              >
                <MenuItem value="">All</MenuItem>
                {locations.map(loc => (
                  <MenuItem key={loc} value={loc}>{loc}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Current Stage</InputLabel>
              <Select
                value={paymentFilters.currentStage}
                onChange={(e) => setPaymentFilters({ ...paymentFilters, currentStage: e.target.value })}
                label="Current Stage"
              >
                <MenuItem value="">All</MenuItem>
                {stages.map(stage => (
                  <MenuItem key={stage} value={stage}>{stage}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Min Due Amount"
              type="number"
              variant="outlined"
              value={paymentFilters.minDueAmount}
              onChange={(e) => setPaymentFilters({ ...paymentFilters, minDueAmount: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Max Due Amount"
              type="number"
              variant="outlined"
              value={paymentFilters.maxDueAmount}
              onChange={(e) => setPaymentFilters({ ...paymentFilters, maxDueAmount: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end">
              <Button
                size="small"
                variant="contained"
                color="secondary"
                startIcon={<ClearIcon />}
                onClick={clearPaymentFilters}
              >
                Clear All Filters
              </Button>
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  };

  const renderUpdatedPaymentFilterSection = () => {
    const locations = filterOptions.updatedPayment.locations;
    const stages = filterOptions.updatedPayment.stages;
    
    return (
      <div className={classes.filterContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Project No"
              variant="outlined"
              value={updatedPaymentFilters.projectNo}
              onChange={(e) => setUpdatedPaymentFilters({ ...updatedPaymentFilters, projectNo: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Location</InputLabel>
              <Select
                value={updatedPaymentFilters.location}
                onChange={(e) => setUpdatedPaymentFilters({ ...updatedPaymentFilters, location: e.target.value })}
                label="Location"
              >
                <MenuItem value="">All</MenuItem>
                {locations.map(loc => (
                  <MenuItem key={loc} value={loc}>{loc}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Current Stage</InputLabel>
              <Select
                value={updatedPaymentFilters.currentStage}
                onChange={(e) => setUpdatedPaymentFilters({ ...updatedPaymentFilters, currentStage: e.target.value })}
                label="Current Stage"
              >
                <MenuItem value="">All</MenuItem>
                {stages.map(stage => (
                  <MenuItem key={stage} value={stage}>{stage}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Min Due Amount"
              type="number"
              variant="outlined"
              value={updatedPaymentFilters.minDueAmount}
              onChange={(e) => setUpdatedPaymentFilters({ ...updatedPaymentFilters, minDueAmount: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Max Due Amount"
              type="number"
              variant="outlined"
              value={updatedPaymentFilters.maxDueAmount}
              onChange={(e) => setUpdatedPaymentFilters({ ...updatedPaymentFilters, maxDueAmount: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Start Expected Date"
              type="date"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              value={updatedPaymentFilters.startDate}
              onChange={(e) => setUpdatedPaymentFilters({ ...updatedPaymentFilters, startDate: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="End Expected Date"
              type="date"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              value={updatedPaymentFilters.endDate}
              onChange={(e) => setUpdatedPaymentFilters({ ...updatedPaymentFilters, endDate: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end">
              <Button
                size="small"
                variant="contained"
                color="secondary"
                startIcon={<ClearIcon />}
                onClick={clearUpdatedPaymentFilters}
              >
                Clear All Filters
              </Button>
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  };

  // Dialog content renderer
  const renderDialogContent = () => {
    const paginatedData = selectedMetricData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    if (selectedMetric === "IDSO") {
      return (
        <div className={classes.tableWrapper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableheaderCell}>S. No</TableCell>
                <TableCell className={classes.tableheaderCell}>Project No</TableCell>
                <TableCell className={classes.tableheaderCell}>Client Name</TableCell>
                <TableCell className={classes.tableheaderCell}>Contact No.</TableCell>
                <TableCell className={classes.tableheaderCell}>Location</TableCell>
                <TableCell className={classes.tableheaderCell}>Current Stage</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, index) => (
                <TableRow key={row._id || index}>
                  <TableCell className={classes.tablecell}>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell className={classes.tablecell}>
                    <span 
                      className={classes.projectLink}
                      onClick={() => handleProjectClick(row?._id)}
                    >
                      {row?.erpProjectNo || 'NA'}
                    </span>
                  </TableCell>
                  <TableCell className={classes.tablecell}>{row?.customerId?.name || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.customerId?.contact_no || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    } else if (selectedMetric === "DSO Payment Not Collected") {
      return (
        <div className={classes.tableWrapper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableheaderCell}>S. No</TableCell>
                <TableCell className={classes.tableheaderCell}>Project No</TableCell>
                <TableCell className={classes.tableheaderCell}>Client Name</TableCell>
                <TableCell className={classes.tableheaderCell}>Contact No.</TableCell>
                <TableCell className={classes.tableheaderCell}>Location</TableCell>
                <TableCell className={classes.tableheaderCell}>Current Stage</TableCell>
                <TableCell className={classes.tableheaderCell}>Design SignOff Date</TableCell>
                <TableCell className={classes.tableheaderCell}>Due Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, index) => (
                <TableRow key={row._id || index}>
                  <TableCell className={classes.tablecell}>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell className={classes.tablecell}>
                    <span 
                      className={classes.projectLink}
                      onClick={() => handleProjectClick(row?._id)}
                    >
                      {row?.erpProjectNo || 'NA'}
                    </span>
                  </TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.name || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.contact_no || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>
                    {row?.customerDesignSignOffDate ? moment(row.customerDesignSignOffDate).format('DD-MM-YYYY') : 
                     row?.designSignOffDate ? moment(row.designSignOffDate).format('DD-MM-YYYY') : 'NA'}
                  </TableCell>
                  <TableCell className={classes.tablecell}>{row?.dueAmount || 'NA'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    } else {
      return (
        <div className={classes.tableWrapper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableheaderCell}>S. No</TableCell>
                <TableCell className={classes.tableheaderCell}>Project No</TableCell>
                <TableCell className={classes.tableheaderCell}>Lead No.</TableCell>
                <TableCell className={classes.tableheaderCell}>Client Name</TableCell>
                <TableCell className={classes.tableheaderCell}>Contact No.</TableCell>
                <TableCell className={classes.tableheaderCell}>Location</TableCell>
                <TableCell className={classes.tableheaderCell}>Current Stage</TableCell>
                <TableCell className={classes.tableheaderCell}>Design SignOff Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, index) => (
                <TableRow key={row._id || index}>
                  <TableCell className={classes.tablecell}>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell className={classes.tablecell}>
                    <span 
                      className={classes.projectLink}
                      onClick={() => handleProjectClick(row?._id)}
                    >
                      {row?.erpProjectNo || 'NA'}
                    </span>
                  </TableCell>
                  <TableCell className={classes.tablecell}>{row?.lead_no || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.name || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.contact_no || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>
                    {row?.customerDesignSignOffDate ? moment(row.customerDesignSignOffDate).format('DD-MM-YYYY') : 
                     row?.designSignOffDate ? moment(row.designSignOffDate).format('DD-MM-YYYY') : 'NA'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    }
  };

  // API calls
  // IDSO/DSO metric-card popups keep their original "fetch everything once" behaviour (limit:-1)
  // — they're small, rarely-opened summary dialogs, out of scope for the server pagination below.
  const fetchIdsoData = async () => {
    setLoadingState(prev => ({ ...prev, idso: true }));
    try {
      const response = await HttpService.IdsoCount({ limit: -1 });
      if(response && response.status === 200){
        const data = response?.data?.data || [];
        setIdsoCount(data.length);
        setIdsoCountData(data);
      }
    } catch (error) {
      console.error("Error fetching IDSO data:", error);
    } finally {
      setLoadingState(prev => ({ ...prev, idso: false }));
    }
  };

  const fetchDsoData = async () => {
    setLoadingState(prev => ({ ...prev, dso: true }));
    try {
      const response = await HttpService.dsoCount({ limit: -1 });
      if (response && response.status === 200) {
        const data = response?.data?.data || [];
        setDsoCount(data.length);
        setDsoCountData(data);
      }
    } catch (error) {
      console.error("Error fetching DSO data:", error);
    } finally {
      setLoadingState(prev => ({ ...prev, dso: false }));
    }
  };

 
  const fetchPaymentData = async () => {
    setLoadingState(prev => ({ ...prev, paymentPopup: true }));
    try {
      const response = await HttpService.PaymentCollectedNotinUnderExecution({ limit: -1 });
      let data = [];
      if (response && response.data) {
        if (response.data.data && Array.isArray(response.data.data)) {
          data = response.data.data;
        } else if (Array.isArray(response.data)) {
          data = response.data;
        }
      }
      setPaymentCount(data.length);
      setPaymentCountData(data);
    } catch (error) {
      console.error("Error fetching Payment data:", error);
    } finally {
      setLoadingState(prev => ({ ...prev, paymentPopup: false }));
    }
  };


  const DsoPaymentNotCollectedYesCondition = async () => {
    setLoadingState(prev => ({ ...prev, yesDso: true }));
    try {
      const response = await HttpService.DsoPaymentNotCollectedYesCondition({
        page: yesDsoPage + 1, limit: yesDsoRowsPerPage, ...buildServerFilterParams(yesDsoDebouncedFilters)
      });
      if (response && response.status === 200) {
        const data = response?.data?.data || [];
        setYesDsoData(data);
        setTableTotalCounts(prev => ({ ...prev, yesDso: response?.data?.totalCount || 0 }));
        mergeFilterOptions('yesDso', data);
      }
    } catch (error) {
      console.error("Error fetching Yes DSO data:", error);
    } finally {
      setLoadingState(prev => ({ ...prev, yesDso: false }));
    }
  }

  const DsoPaymentNotCollectedSecondCondition = async () => {
    setLoadingState(prev => ({ ...prev, secondDso: true }));
    try {
      const response = await HttpService.DsoPaymentNotCollectedSecondCondition({
        page: secondDsoPage + 1, limit: secondDsoRowsPerPage, ...buildServerFilterParams(secondDsoDebouncedFilters)
      });
      if (response && response.status === 200) {
        const data = response?.data?.data || [];
        setSecondDsoData(data);
        setTableTotalCounts(prev => ({ ...prev, secondDso: response?.data?.totalCount || 0 }));
        mergeFilterOptions('secondDso', data);
      }
    } catch (error) {
      console.error("Error fetching second DSO data:", error);
    } finally {
      setLoadingState(prev => ({ ...prev, secondDso: false }));
    }
  }

  const DsoPaymentNotCollectedThirdCondition = async () => {
    setLoadingState(prev => ({ ...prev, thirdDso: true }));
    try {
      const response = await HttpService.DsoPaymentNotCollectedThirdCondition({
        page: thirdDsoPage + 1, limit: thirdDsoRowsPerPage, ...buildServerFilterParams(thirdDsoDebouncedFilters)
      });
      if (response && response.status === 200) {
        const data = response?.data?.data || [];
        setThirdDsoData(data);
        setTableTotalCounts(prev => ({ ...prev, thirdDso: response?.data?.totalCount || 0 }));
        mergeFilterOptions('thirdDso', data);
      }
    } catch (error) {
      console.error("Error fetching third DSO data:", error);
    } finally {
      setLoadingState(prev => ({ ...prev, thirdDso: false }));
    }
  }

  // NEW: Other DSO API call
  const DsoPaymentNotCollectedOtherCondition = async () => {
    setLoadingState(prev => ({ ...prev, otherDso: true }));
    try {
      const response = await HttpService.DsoPaymentNotCollectedOtherCondition({
        page: otherDsoPage + 1, limit: otherDsoRowsPerPage, ...buildServerFilterParams(otherDsoDebouncedFilters)
      });
      if (response && response.status === 200) {
        const data = response?.data?.data || [];
        setOtherDsoData(data);
        setTableTotalCounts(prev => ({ ...prev, otherDso: response?.data?.totalCount || 0 }));
        mergeFilterOptions('otherDso', data);
      }
    } catch (error) {
      console.error("Error fetching Other DSO data:", error);
    } finally {
      setLoadingState(prev => ({ ...prev, otherDso: false }));
    }
  }

  const fetchPaymentTableData = async () => {
    setLoadingState(prev => ({ ...prev, payment: true }));
    try {
      const response = await HttpService.PaymentCollectedNotinUnderExecution({
        page: paymentTablePage + 1, limit: paymentTableRowsPerPage, ...buildServerFilterParams(paymentDebouncedFilters)
      });
      if (response && response.status === 200) {
        const data = response?.data?.data || [];
        setPaymentTableData(data);
        setTableTotalCounts(prev => ({ ...prev, payment: response?.data?.totalCount || 0 }));
        mergeFilterOptions('payment', data);
      }
    } catch (error) {
      console.error("Error fetching Payment table data:", error);
    } finally {
      setLoadingState(prev => ({ ...prev, payment: false }));
    }
  };

  const fetchUpdatedPaymentDateData = async () => {
    setUpdatedPaymentDateLoading(true);
    try {
      const response = await HttpService.getUpdatePaymentDate({
        page: updatedPaymentDatePage + 1, limit: updatedPaymentDateRowsPerPage, ...buildServerFilterParams(updatedPaymentDebouncedFilters)
      });
      if (response && response.status === 200) {
        const data = response?.data?.data || [];
        setUpdatedPaymentDateData(data);
        setTableTotalCounts(prev => ({ ...prev, updatedPayment: response?.data?.totalCount || 0 }));
        mergeFilterOptions('updatedPayment', data);
      }
    } catch (error) {
      console.error("Error fetching Updated Payment Date data:", error);
    } finally {
      setUpdatedPaymentDateLoading(false);
    }
  }

  // Metric-card popups: fetch once on mount, unchanged from before.
  useEffect(() => {
    fetchIdsoData();
    fetchDsoData();
    fetchPaymentData();
  }, []);


  useEffect(() => { DsoPaymentNotCollectedYesCondition(); /* eslint-disable-next-line */ }, [yesDsoPage, yesDsoRowsPerPage, yesDsoDebouncedFilters]);
  useEffect(() => { DsoPaymentNotCollectedSecondCondition(); /* eslint-disable-next-line */ }, [secondDsoPage, secondDsoRowsPerPage, secondDsoDebouncedFilters]);
  useEffect(() => { DsoPaymentNotCollectedThirdCondition(); /* eslint-disable-next-line */ }, [thirdDsoPage, thirdDsoRowsPerPage, thirdDsoDebouncedFilters]);
  useEffect(() => { DsoPaymentNotCollectedOtherCondition(); /* eslint-disable-next-line */ }, [otherDsoPage, otherDsoRowsPerPage, otherDsoDebouncedFilters]);
  useEffect(() => { fetchPaymentTableData(); /* eslint-disable-next-line */ }, [paymentTablePage, paymentTableRowsPerPage, paymentDebouncedFilters]);
  useEffect(() => { fetchUpdatedPaymentDateData(); /* eslint-disable-next-line */ }, [updatedPaymentDatePage, updatedPaymentDateRowsPerPage, updatedPaymentDebouncedFilters]);

 
  useEffect(() => { setFilteredYesDsoData(yesDsoData); }, [yesDsoData]);
  useEffect(() => { setFilteredSecondDsoData(secondDsoData); }, [secondDsoData]);
  useEffect(() => { setFilteredThirdDsoData(thirdDsoData); }, [thirdDsoData]);
  useEffect(() => { setFilteredOtherDsoData(otherDsoData); }, [otherDsoData]);
  useEffect(() => { setFilteredPaymentData(paymentTableData); }, [paymentTableData]);
  useEffect(() => { setFilteredUpdatedPaymentData(updatedPaymentDateData); }, [updatedPaymentDateData]);


  const handleValueClick = (type, metricName) => {
    setSelectedMetric(metricName);
    setShowDetailsDialog(true);
    setPage(0);
    
    if (type === "idso") {
      setSelectedMetricData(idsoCountData);
      setTotalRows(idsoCountData.length);
    } else if (type === "dso") {
      setSelectedMetricData(dsoCountData);
      setTotalRows(dsoCountData.length);
    } else if (type === "payment") {
      setSelectedMetricData(paymentCountData);
      setTotalRows(paymentCountData.length);
    }
  };

  const handleCloseDialog = () => {
    setShowDetailsDialog(false);
    setSelectedMetric(null);
    setSelectedMetricData([]);
    setPage(0);
  };

  const renderFilterToggle = (show, setShow, label) => {
    return (
      <Button
        size="small"
        variant="outlined"
        startIcon={<FilterListIcon />}
        onClick={() => setShow(!show)}
        style={{ marginBottom: '10px', marginRight: '10px' }}
        className={classes.filterButton}
      >
        {show ? 'Hide' : 'Show'} {label} Filters
      </Button>
    );
  };


  const getPaginatedYesDsoData = () => filteredYesDsoData;
  const getPaginatedSecondDsoData = () => filteredSecondDsoData;
  const getPaginatedThirdDsoData = () => filteredThirdDsoData;
  const getPaginatedOtherDsoData = () => filteredOtherDsoData;
  const getPaginatedPaymentData = () => filteredPaymentData;
  const getPaginatedUpdatedPaymentDateData = () => filteredUpdatedPaymentData;

  return (
    <div>
      <h2 style={{ textAlign: 'center', margin: '20px 0', color: '#1C375D' }}>
        RFD Executive Dashboard
      </h2>
      
      {/* Overview Table */}
      <Box className={classes.root}>
        <TableContainer component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>Overview</TableCell>
                <TableCell className={classes.headerCell}>Value / Count</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.cell}>{row.metric}</TableCell>
                  <TableCell className={classes.valueCell} onClick={() => handleValueClick(row.type, row.metric)}>
                    {loadingState[row.type] ? <CircularProgress size={24} /> : row.value}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Details Dialog */}
      <Dialog open={showDetailsDialog} onClose={handleCloseDialog} maxWidth="xl" classes={{ paper: classes.dialogPaper }}>
        <DialogTitle className={classes.dialogTitle}>
          <Typography variant="h6">{selectedMetric} Details ({totalRows} Records)</Typography>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <div className={classes.paginationWrapper}>
            <Button variant="contained" className={classes.downloadButton} onClick={handleDialogDownload} disabled={selectedMetricData.length === 0}>
              <RiFileExcel2Fill style={{ fontSize: "20px", marginRight: '5px' }} />
              Download CSV
            </Button>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100, { label: 'All', value: totalRows }]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(e, newPage) => setPage(newPage)}
              onRowsPerPageChange={handleChangeRowPerPage}
            />
          </div>
          
          {renderDialogContent()}
          
          <CSVLink
            data={csvData}
            headers={selectedMetric === "IDSO" ? idsoCsvHeaders : selectedMetric === "DSO Payment Not Collected" ? dsoCsvHeaders : paymentCsvHeaders}
            filename={`${selectedMetric?.toLowerCase().replace(/ /g, '-')}-data.csv`}
            ref={csvRef}
            style={{ display: "none" }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">Close</Button>
        </DialogActions>
      </Dialog>
      
      {/* Table 1: Yes DSO - 9 Columns */}
      <div className={classes.tableContainer}>
        <div className={classes.sectionTitle}>Table 1. DSO - Payment not collected</div>
        <div className={classes.subNote}>1.1 Possession(Yes), Keys(Yes), Material Delivery Willing(Yes)</div>
        
        {loadingState.yesDso ? (
          <div className={classes.loadingContainer}><CircularProgress /></div>
        ) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              {renderFilterToggle(showYesDsoFilters, setShowYesDsoFilters, '')}
              <Button variant="contained" className={classes.downloadButton} onClick={handleYesDsoDownload} disabled={filteredYesDsoData.length === 0}>
                <RiFileExcel2Fill style={{ fontSize: "20px", marginRight: '5px' }} />
                Download CSV
              </Button>
            </div>
            {showYesDsoFilters && renderYesDsoFilterSection()}
            
            <TableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableheaderCell}>S.No</TableCell>
                    <TableCell className={classes.tableheaderCell}>Project No</TableCell>
                    <TableCell className={classes.tableheaderCell}>Client Name</TableCell>
                    <TableCell className={classes.tableheaderCell}>Contact</TableCell>
                    <TableCell className={classes.tableheaderCell}>Location</TableCell>
                    <TableCell className={classes.tableheaderCell}>Current Stage</TableCell>
                    <TableCell className={classes.tableheaderCell}>Design SignOff Date</TableCell>
                    <TableCell className={classes.tableheaderCell}>Due Amount</TableCell>
                    <TableCell className={classes.tableheaderCell}>Expected Payment Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getPaginatedYesDsoData().map((row, index) => (
                    <TableRow key={row._id || index}>
                      <TableCell className={classes.tablecell}>{yesDsoPage * yesDsoRowsPerPage + index + 1}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <span 
                          className={classes.projectLink}
                          onClick={() => handleProjectClick(row?._id)}
                        >
                          {row?.erpProjectNo || 'NA'}
                        </span>
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.name || row?.customerId?.name || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.contact_no || row?.customerId?.contact_no || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>
                        {row?.customerDesignSignOffDate ? moment(row.customerDesignSignOffDate).format('DD-MM-YYYY') : 
                         row?.designSignOffDate ? moment(row.designSignOffDate).format('DD-MM-YYYY') : 'NA'}
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.dueAmount || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableDateCell 
                          tableKey="yesDso"
                          date={row?.expectedPaymentDate} 
                          projectId={row._id} 
                          fieldName="expectedPaymentDate"
                          label="Payment Date"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 50, 100, { label: 'All', value: tableTotalCounts.yesDso || 1 }]}
                      colSpan={9}
                      count={tableTotalCounts.yesDso}
                      rowsPerPage={yesDsoRowsPerPage}
                      page={yesDsoPage}
                      onPageChange={handleYesDsoPageChange}
                      onRowsPerPageChange={handleYesDsoRowsPerPageChange}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </>
        )}
      </div>

      {/* Table 2: Second DSO - 12 Columns */}
      <div className={classes.tableContainer}>
        <div className={classes.subNote}>1.2 Possession(No), Keys(No), Material Delivery Willing(Yes)</div>
        
        {loadingState.secondDso ? (
          <div className={classes.loadingContainer}><CircularProgress /></div>
        ) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              {renderFilterToggle(showSecondDsoFilters, setShowSecondDsoFilters, '')}
              <Button variant="contained" className={classes.downloadButton} onClick={handleSecondDsoDownload} disabled={filteredSecondDsoData.length === 0}>
                <RiFileExcel2Fill style={{ fontSize: "20px", marginRight: '5px' }} />
                Download CSV
              </Button>
            </div>
            {showSecondDsoFilters && renderSecondDsoFilterSection()}
            
            <TableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableheaderCell}>S.No</TableCell>
                    <TableCell className={classes.tableheaderCell}>Project No</TableCell>
                    <TableCell className={classes.tableheaderCell}>Client Name</TableCell>
                    <TableCell className={classes.tableheaderCell}>Contact</TableCell>
                    <TableCell className={classes.tableheaderCell}>Location</TableCell>
                    <TableCell className={classes.tableheaderCell}>Current Stage</TableCell>
                    <TableCell className={classes.tableheaderCell}>Design SignOff Date</TableCell>
                    <TableCell className={classes.tableheaderCell}>Due Amount</TableCell>
                    <TableCell className={classes.tableheaderCell}>Possession Status</TableCell>
                    <TableCell className={classes.tableheaderCell}>Possession Date</TableCell>
                    <TableCell className={classes.tableheaderCell}>Key Status</TableCell>
                    <TableCell className={classes.tableheaderCell}>Expected Payment Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getPaginatedSecondDsoData().map((row, index) => (
                    <TableRow key={row._id || index}>
                      <TableCell className={classes.tablecell}>{secondDsoPage * secondDsoRowsPerPage + index + 1}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <span 
                          className={classes.projectLink}
                          onClick={() => handleProjectClick(row?._id)}
                        >
                          {row?.erpProjectNo || 'NA'}
                        </span>
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.name || row?.customerId?.name || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.contact_no || row?.customerId?.contact_no || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>
                        {row?.customerDesignSignOffDate ? moment(row.customerDesignSignOffDate).format('DD-MM-YYYY') : 
                         row?.designSignOffDate ? moment(row.designSignOffDate).format('DD-MM-YYYY') : 'NA'}
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.dueAmount || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableSelectCell 
                          tableKey="secondDso"
                          value={row?.propertyPossession} 
                          options={['Yes', 'No']}
                          projectId={row._id} 
                          fieldName="propertyPossession"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableDateCell 
                          tableKey="secondDso"
                          date={row?.propertyPossessionDate} 
                          projectId={row._id} 
                          fieldName="propertyPossessionDate"
                          label="Possession Date"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableSelectCell 
                          tableKey="secondDso"
                          value={row?.hasKeys} 
                          options={['Yes', 'No']}
                          projectId={row._id} 
                          fieldName="hasKeys"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableDateCell 
                          tableKey="secondDso"
                          date={row?.expectedPaymentDate} 
                          projectId={row._id} 
                          fieldName="expectedPaymentDate"
                          label="Payment Date"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 50, 100, { label: 'All', value: tableTotalCounts.secondDso || 1 }]}
                      colSpan={12}
                      count={tableTotalCounts.secondDso}
                      rowsPerPage={secondDsoRowsPerPage}
                      page={secondDsoPage}
                      onPageChange={handleSecondDsoPageChange}
                      onRowsPerPageChange={handleSecondDsoRowsPerPageChange}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </>
        )}
      </div>

      {/* Table 3: Third DSO - 11 Columns */}
      <div className={classes.tableContainer}>
        <div className={classes.subNote}>1.3 Possession(Yes), Keys(No), Material Delivery Willing(No)</div>
        
        {loadingState.thirdDso ? (
          <div className={classes.loadingContainer}><CircularProgress /></div>
        ) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              {renderFilterToggle(showThirdDsoFilters, setShowThirdDsoFilters, '')}
              <Button variant="contained" className={classes.downloadButton} onClick={handleThirdDsoDownload} disabled={filteredThirdDsoData.length === 0}>
                <RiFileExcel2Fill style={{ fontSize: "20px", marginRight: '5px' }} />
                Download CSV
              </Button>
            </div>
            {showThirdDsoFilters && renderThirdDsoFilterSection()}
            
            <TableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableheaderCell}>S.No</TableCell>
                    <TableCell className={classes.tableheaderCell}>Project No</TableCell>
                    <TableCell className={classes.tableheaderCell}>Client Name</TableCell>
                    <TableCell className={classes.tableheaderCell}>Contact</TableCell>
                    <TableCell className={classes.tableheaderCell}>Location</TableCell>
                    <TableCell className={classes.tableheaderCell}>Current Stage</TableCell>
                    <TableCell className={classes.tableheaderCell}>Design SignOff Date</TableCell>
                    <TableCell className={classes.tableheaderCell}>Due Amount</TableCell>
                    <TableCell className={classes.tableheaderCell}>Key Status</TableCell>
                    <TableCell className={classes.tableheaderCell}>Payment Date</TableCell>
                    <TableCell className={classes.tableheaderCell}>Expected Payment Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getPaginatedThirdDsoData().map((row, index) => (
                    <TableRow key={row._id || index}>
                      <TableCell className={classes.tablecell}>{thirdDsoPage * thirdDsoRowsPerPage + index + 1}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <span 
                          className={classes.projectLink}
                          onClick={() => handleProjectClick(row?._id)}
                        >
                          {row?.erpProjectNo || 'NA'}
                        </span>
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.name || row?.customerId?.name || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.contact_no || row?.customerId?.contact_no || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>
                        {row?.customerDesignSignOffDate ? moment(row.customerDesignSignOffDate).format('DD-MM-YYYY') : 
                         row?.designSignOffDate ? moment(row.designSignOffDate).format('DD-MM-YYYY') : 'NA'}
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.dueAmount || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableSelectCell 
                          tableKey="thirdDso"
                          value={row?.hasKeys} 
                          options={['Yes', 'No']}
                          projectId={row._id} 
                          fieldName="hasKeys"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        {row?.materialDeliveryDate ? moment(row.materialDeliveryDate).format('DD-MM-YYYY') : 'NA'}
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableDateCell 
                          tableKey="thirdDso"
                          date={row?.expectedPaymentDate} 
                          projectId={row._id} 
                          fieldName="expectedPaymentDate"
                          label="Payment Date"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 50, 100, { label: 'All', value: tableTotalCounts.thirdDso || 1 }]}
                      colSpan={11}
                      count={tableTotalCounts.thirdDso}
                      rowsPerPage={thirdDsoRowsPerPage}
                      page={thirdDsoPage}
                      onPageChange={handleThirdDsoPageChange}
                      onRowsPerPageChange={handleThirdDsoRowsPerPageChange}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </>
        )}
      </div>

      {/* Table 4: Other DSO - 12 Columns (NEW) */}
      <div className={classes.tableContainer}>
        <div className={classes.subNote}>Additional conditions</div>
        
        {loadingState.otherDso ? (
          <div className={classes.loadingContainer}><CircularProgress /></div>
        ) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              {renderFilterToggle(showOtherDsoFilters, setShowOtherDsoFilters, '')}
              <Button variant="contained" className={classes.downloadButton} onClick={handleOtherDsoDownload} disabled={filteredOtherDsoData.length === 0}>
                <RiFileExcel2Fill style={{ fontSize: "20px", marginRight: '5px' }} />
                Download CSV
              </Button>
            </div>
            {showOtherDsoFilters && renderOtherDsoFilterSection()}
            
            <TableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableheaderCell}>S.No</TableCell>
                    <TableCell className={classes.tableheaderCell}>Project No</TableCell>
                    <TableCell className={classes.tableheaderCell}>Client Name</TableCell>
                    <TableCell className={classes.tableheaderCell}>Contact</TableCell>
                    <TableCell className={classes.tableheaderCell}>Location</TableCell>
                    <TableCell className={classes.tableheaderCell}>Current Stage</TableCell>
                    <TableCell className={classes.tableheaderCell}>Design SignOff Date</TableCell>
                    <TableCell className={classes.tableheaderCell}>Due Amount</TableCell>
                    <TableCell className={classes.tableheaderCell}>Possession Status</TableCell>
                    <TableCell className={classes.tableheaderCell}>Possession Date</TableCell>
                    <TableCell className={classes.tableheaderCell}>Key Status</TableCell>
                    <TableCell className={classes.tableheaderCell}>Material Delivery Willing</TableCell>
                    <TableCell className={classes.tableheaderCell}>Expected Payment Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getPaginatedOtherDsoData().map((row, index) => (
                    <TableRow key={row._id || index}>
                      <TableCell className={classes.tablecell}>{otherDsoPage * otherDsoRowsPerPage + index + 1}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <span 
                          className={classes.projectLink}
                          onClick={() => handleProjectClick(row?._id)}
                        >
                          {row?.erpProjectNo || 'NA'}
                        </span>
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.name || row?.customerId?.name || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.contact_no || row?.customerId?.contact_no || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>
                        {row?.customerDesignSignOffDate ? moment(row.customerDesignSignOffDate).format('DD-MM-YYYY') : 
                         row?.designSignOffDate ? moment(row.designSignOffDate).format('DD-MM-YYYY') : 'NA'}
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.dueAmount || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableSelectCell 
                          tableKey="otherDso"
                          value={row?.propertyPossession} 
                          options={['Yes', 'No']}
                          projectId={row._id} 
                          fieldName="propertyPossession"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableDateCell 
                          tableKey="otherDso"
                          date={row?.propertyPossessionDate} 
                          projectId={row._id} 
                          fieldName="propertyPossessionDate"
                          label="Possession Date"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableSelectCell 
                          tableKey="otherDso"
                          value={row?.hasKeys} 
                          options={['Yes', 'No']}
                          projectId={row._id} 
                          fieldName="hasKeys"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableSelectCell 
                          tableKey="otherDso"
                          value={row?.materialDeliveryWilling} 
                          options={['Yes', 'No']}
                          projectId={row._id} 
                          fieldName="materialDeliveryWilling"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableDateCell 
                          tableKey="otherDso"
                          date={row?.expectedPaymentDate} 
                          projectId={row._id} 
                          fieldName="expectedPaymentDate"
                          label="Payment Date"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 50, 100, { label: 'All', value: tableTotalCounts.otherDso || 1 }]}
                      colSpan={12}
                      count={tableTotalCounts.otherDso}
                      rowsPerPage={otherDsoRowsPerPage}
                      page={otherDsoPage}
                      onPageChange={handleOtherDsoPageChange}
                      onRowsPerPageChange={handleOtherDsoRowsPerPageChange}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </>
        )}
      </div>

      {/* Table 5: Payment Collected Not in Under Execution - 12 Columns */}
      <div className={classes.tableContainer}>
        <div className={classes.sectionTitle}>Table 2. Payment Collected Not in Under Execution</div>
        <div className={classes.subNote}>2.1 Projects where payment has been collected but not moved to under execution stage</div>
        
        {loadingState.payment ? (
          <div className={classes.loadingContainer}><CircularProgress /></div>
        ) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              {renderFilterToggle(showPaymentFilters, setShowPaymentFilters, '')}
              <Button variant="contained" className={classes.downloadButton} onClick={handlePaymentTableDownload} disabled={filteredPaymentData.length === 0}>
                <RiFileExcel2Fill style={{ fontSize: "20px", marginRight: '5px' }} />
                Download CSV
              </Button>
            </div>
            {showPaymentFilters && renderPaymentFilterSection()}
            
            <TableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableheaderCell}>S.No</TableCell>
                    <TableCell className={classes.tableheaderCell}>Project No</TableCell>
                    <TableCell className={classes.tableheaderCell}>Lead No.</TableCell>
                    <TableCell className={classes.tableheaderCell}>Client Name</TableCell>
                    <TableCell className={classes.tableheaderCell}>Contact</TableCell>
                    <TableCell className={classes.tableheaderCell}>Location</TableCell>
                    <TableCell className={classes.tableheaderCell}>Current Stage</TableCell>
                    <TableCell className={classes.tableheaderCell}>Collected Amount</TableCell>
                    <TableCell className={classes.tableheaderCell}>Payment Collection Date</TableCell>
                    <TableCell className={classes.tableheaderCell}>Pending Days</TableCell>
                    <TableCell className={classes.tableheaderCell}>Expected Material Date</TableCell>
                    <TableCell className={classes.tableheaderCell}>Remark</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getPaginatedPaymentData().map((row, index) => (
                    <TableRow key={row._id || index}>
                      <TableCell className={classes.tablecell}>{paymentTablePage * paymentTableRowsPerPage + index + 1}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <span 
                          className={classes.projectLink}
                          onClick={() => handleProjectClick(row?._id)}
                        >
                          {row?.erpProjectNo || 'NA'}
                        </span>
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.lead_no || row?.uniqueLeadNumber || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.name || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.contact_no || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.totalPaid || 0}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.lastPaymentDate ? moment(row.lastPaymentDate).format('DD-MM-YYYY') : 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.pendingDays || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableDateCell 
                          tableKey="payment"
                          date={row?.expectedmaterialDeliveryDate} 
                          projectId={row._id} 
                          fieldName="expectedmaterialDeliveryDate"
                          label="Material Delivery Date"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableTextCell 
                          tableKey="payment"
                          value={row?.remark} 
                          projectId={row._id} 
                          fieldName="remark"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 50, 100, { label: 'All', value: tableTotalCounts.payment || 1 }]}
                      colSpan={12}
                      count={tableTotalCounts.payment}
                      rowsPerPage={paymentTableRowsPerPage}
                      page={paymentTablePage}
                      onPageChange={handlePaymentTablePageChange}
                      onRowsPerPageChange={handlePaymentTableRowsPerPageChange}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </>
        )}
      </div>

      {/* Table 6: Updated Expected Payment Date - 11 Columns */}
      <div className={classes.tableContainer}>
        <div className={classes.sectionTitle}>Table 3. Updated Expected Payment Date</div>
        <div className={classes.subNote}>3.1 Projects with updated expected payment date</div>
        
        {updatedPaymentDateLoading ? (
          <div className={classes.loadingContainer}><CircularProgress /></div>
        ) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              {renderFilterToggle(showUpdatedPaymentFilters, setShowUpdatedPaymentFilters, '')}
              <Button variant="contained" className={classes.downloadButton} onClick={handleUpdatedPaymentDateDownload} disabled={filteredUpdatedPaymentData.length === 0}>
                <RiFileExcel2Fill style={{ fontSize: "20px", marginRight: '5px' }} />
                Download CSV
              </Button>
            </div>
            {showUpdatedPaymentFilters && renderUpdatedPaymentFilterSection()}
            
            <TableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableheaderCell}>S.No</TableCell>
                    <TableCell className={classes.tableheaderCell}>Project No</TableCell>
                    <TableCell className={classes.tableheaderCell}>Lead No.</TableCell>
                    <TableCell className={classes.tableheaderCell}>Client Name</TableCell>
                    <TableCell className={classes.tableheaderCell}>Contact</TableCell>
                    <TableCell className={classes.tableheaderCell}>Location</TableCell>
                    <TableCell className={classes.tableheaderCell}>Current Stage</TableCell>
                    <TableCell className={classes.tableheaderCell}>Expected Payment Date</TableCell>
                    <TableCell className={classes.tableheaderCell}>Due Amount</TableCell>
                    <TableCell className={classes.tableheaderCell}>Last Communication</TableCell>
                    <TableCell className={classes.tableheaderCell}>Latest Notes</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getPaginatedUpdatedPaymentDateData().map((row, index) => (
                    <TableRow key={row._id || index}>
                      <TableCell className={classes.tablecell}>{updatedPaymentDatePage * updatedPaymentDateRowsPerPage + index + 1}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <span 
                          className={classes.projectLink}
                          onClick={() => handleProjectClick(row?._id)}
                        >
                          {row?.erpProjectNo || 'NA'}
                        </span>
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.lead_no || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.name || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.contact_no || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.expectedPaymentDate ? moment(row.expectedPaymentDate).format('DD-MM-YYYY') : 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.dueAmount || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.lastCommunicationDate ? moment(row.lastCommunicationDate).format('DD-MM-YYYY') : 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.recentNote?.notes || 'NA'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 50, 100, { label: 'All', value: tableTotalCounts.updatedPayment || 1 }]}
                      colSpan={11}
                      count={tableTotalCounts.updatedPayment}
                      rowsPerPage={updatedPaymentDateRowsPerPage}
                      page={updatedPaymentDatePage}
                      onPageChange={handleUpdatedPaymentDatePageChange}
                      onRowsPerPageChange={handleUpdatedPaymentDateRowsPerPageChange}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </>
        )}
      </div>
    </div>
  );
};
 
RfdExecutiveDashboarad.propTypes = {
  setLoading: PropTypes.func.isRequired,
  setSnackInfo: PropTypes.func.isRequired,
};

export default connect(null, { setLoading, setSnackInfo })(RfdExecutiveDashboarad);